import { useEffect, useRef, useState } from 'react';

// ── Excel Upload Menu (Download Template / Upload File) ──────────────────────
export default function ExcelUploadMenu({ loading, onDownloadTemplate, onUploadClick, onDownloadData, downloadDataLabel = 'Download Data' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        className="btn-secondary flex items-center gap-1.5"
        disabled={loading}
        onClick={() => setOpen((o) => !o)}
      >
        {loading ? 'Uploading…' : 'Excel Upload'}
        {!loading && (
          <svg viewBox="0 0 20 20" fill="currentColor" className="w-3.5 h-3.5">
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
          </svg>
        )}
      </button>
      {open && (
        <div className="absolute right-0 z-30 mt-1 w-48 bg-white rounded-xl shadow-lg border border-gray-100 py-1">
          <button
            type="button"
            onClick={() => { setOpen(false); onDownloadTemplate(); }}
            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Download Template
          </button>
          <button
            type="button"
            onClick={() => { setOpen(false); onUploadClick(); }}
            className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
          >
            Upload File
          </button>
          {onDownloadData && (
            <button
              type="button"
              onClick={() => { setOpen(false); onDownloadData(); }}
              className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
            >
              {downloadDataLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
